'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var ArrowUpThin = function ArrowUpThin(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 10 6' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'v'
      ),
      _react2.default.createElement('path', { d: 'M1 5l4-4 4 4', stroke: 'currentColor', fill: 'none', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = ArrowUpThin;
//# sourceMappingURL=ArrowUpThin.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/ArrowUpThin.js